var React = require('react');

function Branch (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.154 5.77A3 3 0 102 5.83v4.34a3.001 3.001 0 102 0V8.466C4.588 8.805 5.271 9 6 9h2a2 2 0 011.846 1.23 3.001 3.001 0 102.061-.09A4.001 4.001 0 008 7H6a2 2 0 01-1.846-1.23zM4 3a1 1 0 11-2 0 1 1 0 012 0zm0 10a1 1 0 11-2 0 1 1 0 012 0zm7 1a1 1 0 100-2 1 1 0 000 2z","fill":"#919DAF"}));
}

Branch.defaultProps = {"width":"14","height":"16","viewBox":"0 0 14 16","fill":"none"};

module.exports = Branch;

Branch.default = Branch;
